
import Sidebar from './Sidebar';
import Navbar from './Navbar';
export default function Layout({ children }) {
  return (
    <div className="min-vh-100 bg-light">
      {/* 1. The Sidebar remains fixed at 260px */}
      <Sidebar />

      {/* 2. The Main Content Area */}
      <main
        style={{
          marginLeft: '260px', // Matches the sidebar width exactly
          minHeight: '100vh',
          width: 'calc(100% - 260px)', // Ensures content doesn't overflow horizontally
          transition: 'all 0.3s ease'
        }}
      >
        <Navbar />
        <div className="p-4 p-md-2">


          {children}
        </div>
      </main>
    </div>
  );
}
